
        import '/home/builduser/work/c1dd1064fea009a6/santa-editor/packages/leftBar/menuButtonLabel/menuButtonLabel.scss.css.virtualfile';
        module.exports = {"label-box":"_label-box_ig60g_7","labelBox":"_label-box_ig60g_7"};